import { render, staticRenderFns } from "./DiagnosisPlans.vue?vue&type=template&id=5be24c56&"
import script from "./DiagnosisPlans.vue?vue&type=script&lang=js&"
export * from "./DiagnosisPlans.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports